// @ts-nocheck
export const localeCodes =  [
  "en",
  "da",
  "de",
  "es",
  "fi",
  "fr-CA",
  "fr-FR",
  "it",
  "nl",
  "no",
  "pt-BR",
  "pt-PT",
  "sv"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_998c0b20",
      load: () => import("#nuxt-i18n/998c0b20" /* webpackChunkName: "locale_en_46json_998c0b20" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_9c9b19aa",
      load: () => import("#nuxt-i18n/9c9b19aa" /* webpackChunkName: "locale_da_46json_9c9b19aa" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_dc3e7710",
      load: () => import("#nuxt-i18n/dc3e7710" /* webpackChunkName: "locale_de_46json_dc3e7710" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_5cf5ae40",
      load: () => import("#nuxt-i18n/5cf5ae40" /* webpackChunkName: "locale_es_46json_5cf5ae40" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_892e1cc9",
      load: () => import("#nuxt-i18n/892e1cc9" /* webpackChunkName: "locale_fi_46json_892e1cc9" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_4e90b984",
      load: () => import("#nuxt-i18n/4e90b984" /* webpackChunkName: "locale_fr_45CA_46json_4e90b984" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_94f49a00",
      load: () => import("#nuxt-i18n/94f49a00" /* webpackChunkName: "locale_fr_45FR_46json_94f49a00" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_2b827e4e",
      load: () => import("#nuxt-i18n/2b827e4e" /* webpackChunkName: "locale_it_46json_2b827e4e" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_1da6e6a9",
      load: () => import("#nuxt-i18n/1da6e6a9" /* webpackChunkName: "locale_nl_46json_1da6e6a9" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_f1635a09",
      load: () => import("#nuxt-i18n/f1635a09" /* webpackChunkName: "locale_no_46json_f1635a09" */),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_10b50af4",
      load: () => import("#nuxt-i18n/10b50af4" /* webpackChunkName: "locale_pt_45BR_46json_10b50af4" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_9af325b5",
      load: () => import("#nuxt-i18n/9af325b5" /* webpackChunkName: "locale_pt_45PT_46json_9af325b5" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_a367f9df",
      load: () => import("#nuxt-i18n/a367f9df" /* webpackChunkName: "locale_sv_46json_a367f9df" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: undefined
  },
  {
    code: "da",
    language: undefined
  },
  {
    code: "de",
    language: undefined
  },
  {
    code: "es",
    language: undefined
  },
  {
    code: "fi",
    language: undefined
  },
  {
    code: "fr-CA",
    language: undefined
  },
  {
    code: "fr-FR",
    language: undefined
  },
  {
    code: "it",
    language: undefined
  },
  {
    code: "nl",
    language: undefined
  },
  {
    code: "no",
    language: undefined
  },
  {
    code: "pt-BR",
    language: undefined
  },
  {
    code: "pt-PT",
    language: undefined
  },
  {
    code: "sv",
    language: undefined
  }
]
/** client **/

/** client-end **/